import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_MESSAGE_PREFERENCES_NBA: MijnRoute = {
    path: 'nba',
    navigationEvent: 'toBerichtvoorkeurenNba',
    regex: /^\/zelf-regelen\/berichtvoorkeuren\/nba$/,
    webcomponent: 'mijn-klant-toestemmingen-webcomponent',
    internalPath: '/nba'
};
